import { utils } from 'framework7';
import { useAuthStore } from '../pinia-stores/auth.js';

export function buildR2Doc(file) {
  return {
    fileName: file.name,
    contentType: file.type,
    alt: file.name,
    fileId: `${utils.id('xxxx-xxxx-xxxx-xxxx')}/${file.name}`,
    size: file.size,
    fileType: 'image',
    url: window.URL.createObjectURL(file),
    file,
  };
}

export async function uploadImageToR2(file, shortId) {
  const auth = useAuthStore();
  auth.clearDocumentsUrl();
  auth.setDocumentsUrl(buildR2Doc(file));
  await auth.postR2Document({
    shortId: shortId || utils.id(),
    bucketName: import.meta.env.VITE_R2_PUBLIC_BUCKET_NAME,
  });
  const uploaded = auth.documentsUrl.find((doc) => doc.fileName === file.name);
  const url =
    uploaded?.url && !uploaded.url.startsWith('blob:') ? uploaded.url : '';
  auth.clearDocumentsUrl();
  return url;
}
